import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { LoremGuard } from 'src/core/guards/lorem.guard';
import { SessionGuard } from 'src/core/guards/session.guard';
import { AnalysisService } from 'src/core/services/analysis.service';
import { AppService } from 'src/core/services/app.service';
import { BootstrapService } from 'src/core/services/bootstrap.service';
import { CashService } from 'src/core/services/cash.service';
import { ConfigurationService } from 'src/core/services/configuration.service';
import { ContractsService } from 'src/core/services/contracts.service';
import { DateSelectorService } from 'src/core/services/date-selector-service';
import { DocumentsService } from 'src/core/services/documents.service';
import { MarketSelectorService } from 'src/core/services/market-selector.service';
import { MarketService } from 'src/core/services/market.service';
import { MixpanelService } from 'src/core/services/mixpanel.service';
import { MonitorWatchlistService } from 'src/core/services/monitorWatchlist.service';
import { UserPreferencesService } from 'src/core/services/userPreferences.service';
import { NewsService } from 'src/core/services/news.service';
import { NotificationService } from 'src/core/services/notification.service';
import { OperationService } from 'src/core/services/operation.service';
import { PatronService } from 'src/core/services/patron.service';
import { PositionService } from 'src/core/services/position.service';
import { PurchaseOpportunitiesTabSelectorService } from 'src/core/services/purchaseOpportunitiesTabSelector.service';
import { SearchService } from 'src/core/services/search.service';
import { SearchIssueService } from 'src/core/services/searchIssue.service';
import { SessionService } from 'src/core/services/session.service';
import { StorageService } from 'src/core/services/storage.service';
import { TechRulesTabSelectorService } from 'src/core/services/techRulesTabSelector.service';
import { TradeService } from 'src/core/services/trade.service';
import { UserService } from 'src/core/services/user.service';
import { UtilitiesService } from 'src/core/services/utilities.service';
import { WatchlistService } from 'src/core/services/watchlist.service';
import { SolaceProxyService } from 'src/core/solace/solace.proxy.service';
import { ApiGatewayService } from 'src/shared';
import { AnalyticsTrackingService } from './services/analyticsTracking.service';
import { GeolocationService } from './services/geolocation.service';
import { OperationTimeService } from './services/operation-time.service';
import { PositionSolaceService } from './services/position-solace.service';
import { PriceAlertsService } from './services/price-alerts.service';
import { PuppetService } from './services/puppet.service';
import { AppManagementService } from '@services/appManagement.service';
import { ContractManagementService } from '@services/contractManagement.service';
import { PortfolioService } from '@services/portfolio.service';
import { SecurityService } from '@services/security.service';
import { LegacyWatchlistService } from '@services/legacyWatchlist.service';
import { MigrateUserPreferencesService } from '@services/migrateUserPreferences.service';

@NgModule({
  imports: [CommonModule],
})
export class CoreModule {
  static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        // Core Services
        AppManagementService,
        ContractManagementService,
        PortfolioService,
        SecurityService,
        ConfigurationService,
        AnalysisService,
        AppService,
        BootstrapService,
        UtilitiesService,
        MonitorWatchlistService,
        LegacyWatchlistService,
        MigrateUserPreferencesService,
        UserPreferencesService,
        DateSelectorService,
        MarketSelectorService,
        TechRulesTabSelectorService,
        PurchaseOpportunitiesTabSelectorService,
        SearchIssueService,
        NotificationService,
        GeolocationService,
        SearchService,
        SessionService,
        OperationService,
        MarketService,
        ContractsService,
        NewsService,
        PositionService,
        PriceAlertsService,
        PuppetService,
        TradeService,
        CashService,
        DocumentsService,
        WatchlistService,
        // Utilities
        StorageService,
        // Solace
        SolaceProxyService,
        // Guards
        SessionGuard,
        LoremGuard,
        // Shared
        ApiGatewayService,
        UserService,
        PositionSolaceService,
        OperationTimeService,
        PatronService,
        // Analytics
        AnalyticsTrackingService,
        MixpanelService,
      ],
    };
  }
}
